// G-1i: Snowflake remediation variants, next to the kind (merged into
// REMEDIATION_HINTS through the snowflake manifest's `outputs.hints`).
// Reviewed with its base hints (s-nielsen, 2026-10-06, D-CI-52); steps match
// adapters/snowflake-collector.ts pass rules.
export const SNOWFLAKE_HINTS = {
    idp_mfa_enforced: {
        steps: [
            'In Snowsight go to Governance & security > Users & roles and find person users that sign in with a password.',
            'Have each enroll in MFA, or remove the password so they sign in only through your SSO identity provider.',
            'Require MFA for password sign-ins with an authentication policy (MFA_ENROLLMENT = REQUIRED) set on the account.',
            'Turn scripts and pipelines into TYPE = SERVICE users with key-pair auth; LEGACY_SERVICE users are counted separately.',
        ],
        doc_url: 'https://docs.snowflake.com/en/user-guide/security-mfa',
    },
    idp_admins_minimized: {
        steps: [
            'Run SHOW GRANTS OF ROLE ACCOUNTADMIN and SHOW GRANTS OF ROLE SECURITYADMIN to list who holds them.',
            'REVOKE the role from users who do not need it daily; give them SYSADMIN, USERADMIN or a custom role instead.',
            'Do not grant ACCOUNTADMIN or SECURITYADMIN to custom roles; the check fails while any custom role inherits them.',
            'Keep direct holders at or below the threshold (default 5), including break-glass users.',
        ],
        doc_url: 'https://docs.snowflake.com/en/user-guide/security-access-control-considerations',
    },
    saas_audit_logging_enabled: {
        steps: [
            'Snowflake login history is always on and kept 365 days; this check fails only when the connector cannot read it.',
            'GRANT DATABASE ROLE SNOWFLAKE.SECURITY_VIEWER TO ROLE <GAC Pro role>, and USAGE on its warehouse.',
            'Re-run the connector. Export LOGIN_HISTORY to your SIEM if you need retention beyond a year.',
        ],
        doc_url: 'https://docs.snowflake.com/en/sql-reference/account-usage/login_history',
    },
    cloud_network_restricted: {
        steps: [
            'Create a network policy whose allowed list holds only your corporate, VPN and integration egress ranges (never 0.0.0.0/0).',
            'Activate it for the account: ALTER ACCOUNT SET NETWORK_POLICY = <policy>.',
            'Give the GAC Pro service user its own user-level network policy so the connector keeps working.',
            'Account Usage lags up to 2 hours; re-run the connector after that.',
        ],
        doc_url: 'https://docs.snowflake.com/en/user-guide/network-policies',
    },
};
//# sourceMappingURL=snowflake.js.map